import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import _ from 'lodash'
import Button from '@material-ui/core/Button';
import {withRouter} from "react-router-dom";
import { inject, observer } from 'mobx-react';
import { autorun } from 'mobx';
import {pending, done, error} from '../stores/State'
import Chip from '@material-ui/core/Chip';
import TextField from '@material-ui/core/TextField';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';
import CircularProgress from '@material-ui/core/CircularProgress';

@inject('store')
@observer
class EditAccount extends Component {
  componentWillMount(){
    this.autorunHandler = autorun(()=>{
      if(_.get(this.props.store.accountStore.account, 'saveState') === done){
        this.props.history.push(`/accounts/${this.props.match.params.id}`)     
      }
    })
    this.fetchAccount();
  }

  fetchAccount(){
    const { accountStore } = this.props.store;
    accountStore.fetchAccount(this.props.match.params.id);
  }

  componentWillUnmount(){
    this.autorunHandler();
  }

  save(){
    const { accountStore } = this.props.store;    
    const account = accountStore.account;
    account.save();
  }

  renderRecipients(){
    const { classes } = this.props;
    const { account } = this.props.store.accountStore;

    if(!account) return null;

    return account.inventory_alert_recipients.map((email)=>(
        <Chip
        label={email}
        key={email}
        onDelete={()=>account.removeRecipient(email)}
        className={classes.chip}
      />
    ))
  }

  handleRecipientChanged(event){
    const uiStore = this.props.store.editAccountUIStore;
    uiStore.setRecipientEmail(event.target.value);
  }
/*
  validate(){
    const { account } = this.props.store.accountStore;
    
    var constraints = {
      email: {
        presence: {message: 'Missing'},
        email: {message: 'Not a valid email'}
      },
    };
    if(account){
      constraints.email.exclusion = {
        within: account.inventory_alert_recipients.reduce((object, email)=>{return {...object, [email]: email}}, {}),
        message: "^%{value} is already a recipient"
      }
    }

    const errors = validate({email: this.recipientToAdd}, constraints, {fullMessages: false})
    this.errors = errors || [];
  }
*/

  handleAddRecipient(){
    const { account } = this.props.store.accountStore; 
    const uiStore = this.props.store.editAccountUIStore;
    
    account.addRecipient(uiStore.recipientEmail);
    uiStore.clearRecipientEmail();
  }
  
  renderErrors(key){
    const uiStore = this.props.store.editAccountUIStore;
    if(! uiStore.dirty[key]) return null;
    
    const errors = uiStore.errors[key];
    if(!errors) return null;
    return errors.map((error)=><Typography color='error'>{error}</Typography>)
  }

  render() {
    const { classes, theme } = this.props;
    const { account, accountState } = this.props.store.accountStore;

    const sliderColor = theme.palette.primary[200];
    const uiStore = this.props.store.editAccountUIStore;    
    
    if(accountState === pending) return <CircularProgress />
    if(!account) return null;

    return (<Grid container spacing={24} direction='column'>
      <Grid item xs={12}>
          <Typography variant='display3'>{account.name}</Typography>
      </Grid>

      <Grid item xs={12} md={6}>
        <Paper className={classes.paper}>
            <Typography variant='title'>Inventory alert limit</Typography>
            <Typography>After any inventory location's fill rate exceeds the alert limit, an alert email will be sent to the alert recipients.</Typography>
            <Slider 
            trackStyle={{backgroundColor: sliderColor}}
            handleStyle={{borderColor: sliderColor}}                
            min={10}
            max={100}
            value={account.inventory_alert_limit*100}
            onChange={(value)=>account.setAlertLimit(value/100)}/>

            <Typography variant='body2'>{(account.inventory_alert_limit*100).toFixed(0)}%</Typography>
          </Paper>
      </Grid>

      <Grid item xs={12} md={6}>
        <Paper className={classes.paper}>
            <Typography variant='title'>Inventory alert recipients</Typography>
            <div className={classes.recipientsContainer}>
              {this.renderRecipients()}
            </div>
            <TextField
              label='Recipient email'
              type='email'
              className={classes.recipientTextField}
              value={uiStore.recipientEmail}
              onChange={this.handleRecipientChanged.bind(this)}
            />
            <Button
              onClick={()=>this.handleAddRecipient()}
              type="submit"
              variant="contained"
              size="small"
              disabled={!_.isNil(_.get(uiStore.errors,'recipientEmail'))}>Add recipient
            </Button>
            {this.renderErrors('email')}
          </Paper>
      </Grid>

      <Grid item xs={12}>
        <Button variant="contained" type="submit" onClick={()=>account.save()}>Save</Button>
      </Grid>
    </Grid>)
  }
}

const styles = theme => ({
  paper:{
    padding: 20,
  },
  chip: {
    margin: 4,
  },
  recipientTextField:{
    marginRight: 5,
    width: 300
  },
  recipientsContainer:{
    display: 'flex',
    flexWrap: 'wrap',
  }
});

export default withRouter(withStyles(styles, {withTheme: true})(EditAccount));


// WEBPACK FOOTER //
// ./src/components/EditAccount.js